import helpers from './helpers';
import fb from './fb';

export default ( Vue ) =>
{
    Object.defineProperties( Vue.prototype, {
        $helpers: {
            get()
            {
                return helpers;
            }
        },
        $fb: {
            get()
            {
                return fb;
            }
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/plugins/index.js